import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { workspacesApi as r } from "@maat/api-main";
//#region src/workspaces/useUpdateWorkspaceProfileMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.updateProfile(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useUpdateWorkspaceProfileMutation };
